import { noop } from 'lodash';

export type DeferredClipboardWrite = {
  cancel: () => void;
  complete: (text: string) => Promise<boolean>;
};

export function beginDeferredClipboardWrite(): DeferredClipboardWrite | null {
  if (
    typeof navigator === 'undefined' ||
    typeof ClipboardItem === 'undefined' ||
    typeof navigator.clipboard?.write !== 'function'
  ) {
    return null;
  }

  let resolveText!: (text: string) => void;
  let rejectText!: (reason?: unknown) => void;
  let isSettled = false;

  const textPromise = new Promise<string>((resolve, reject) => {
    resolveText = resolve;
    rejectText = reject;
  });

  const clipboardWritePromise = navigator.clipboard.write([
    new ClipboardItem({
      'text/plain': textPromise.then(
        (text) => new Blob([text], { type: 'text/plain' })
      ),
    }),
  ]);

  const settle = () => {
    isSettled = true;
  };

  return {
    cancel: () => {
      if (isSettled) {
        return;
      }

      settle();
      rejectText(new Error('Aborted'));
      clipboardWritePromise.catch(noop);
    },
    complete: async (text: string) => {
      if (isSettled) {
        return false;
      }

      settle();
      resolveText(text);

      try {
        await clipboardWritePromise;
        return true;
      } catch {
        return false;
      }
    },
  };
}
